export const getLastSavedLabel = ({ lastSavedAt, t }: { lastSavedAt: Date; t: (key: string) => string }): string => {
  const now = new Date();
  const diffMs = now.getTime() - lastSavedAt.getTime();
  const diffSeconds = Math.floor(diffMs / 1000);
  const diffMinutes = Math.floor(diffSeconds / 60);

  if (diffSeconds < 5) return t("Saved just now");
  if (diffSeconds < 60) return t("Saved less than a minute ago");
  if (diffMinutes === 1) return t("Saved 1 minute ago");
  if (diffMinutes < 60) return t("Saved {{minutes}} minutes ago").replace("{{minutes}}", String(diffMinutes));
  return t("Saved at {{time}}").replace(
    "{{time}}",
    lastSavedAt.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
};
